import React from 'react';
import HeaderLink from './HeaderLink';

const Header = () => (
    <div className="header">
        <div className="header-left">
            <i className="g72-swoosh header-icon" />
            <div className="header-underline">
                <HeaderLink name={'srcChange'}>
                    <h4>Publish PCX Library</h4>
                </HeaderLink>
            </div>
        </div>
    </div>
);


export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header.js